// extracted by mini-css-extract-plugin
export default {"container":"CheckProfile_container__+r97H","spacingText":"CheckProfile_spacingText__IbOH8","spacingInput":"CheckProfile_spacingInput__8s+dF"};